import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import { getStatic, getAllEditions } from '../reducers';
import SupportRow from '../components/support/SupportRow';
import SectionHeader from '../components/SectionHeader';

class Support extends Component {
  componentDidMount() {
    this.fetchData();
    document.querySelector('.main-wrapper').classList.add('on-full');
  }
  componentWillUnmount() { // eslint-disable-line
    document.querySelector('.main-wrapper').classList.remove('on-full');
  }
  fetchData() {
    const { fetchPage, pageId } = this.props;
    fetchPage(pageId);
  }
  render() {
    const { lang, support, editions } = this.props;
    const FormattedHtml = () => ({ __html: support.body });
    return (
      <div className="fold fold--support fold--main fold--main--full">
        <div className="fold--main__inner">
          <section className="fold__col fold__col--main">
            <SectionHeader lang={lang} title="support" />
            <div className="scroll-wrapper">
              <div className="fold__col__body">
                <div
                  className="content-row content-row--support--intro"
                  dangerouslySetInnerHTML={FormattedHtml()}
                />
                {
                  support.all ?
                    support.all.sort((a, b) => a.edition < b.edition).map(row =>
                      <SupportRow lang={lang} editions={editions} key={row.edition} {...row} />) :
                      null
                }
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

Support.propTypes = {
  lang: PropTypes.string.isRequired,
  editions: PropTypes.arrayOf(PropTypes.object).isRequired,
  support: PropTypes.shape({
    body: PropTypes.string,
  }).isRequired,
  fetchPage: PropTypes.func.isRequired,
  pageId: PropTypes.string.isRequired,
};

const mapStateToProps = (state, { route, lang }) => {
  const regex = lang === 'ar' ?
  /(\/:lang\/)/ : /\//;
  const pageId = route.path.replace(regex, '');
  return {
    support: getStatic(state, pageId),
    editions: getAllEditions(state),
    pageId,
  };
};

Support = connect(//eslint-disable-line
  mapStateToProps,
  actions,
)(Support);

export default Support;



// WEBPACK FOOTER //
// ./js/containers/Support.js